import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';
import {
  EXTERNAL_MAILBOX_CONFIGURATIONS_QUERY_KEY,
  EXTERNAL_MAILBOX_CONFIGURATIONS_URL,
} from './use-load-external-mailbox-configurations';

export type DeleteExternalMailboxConfigurationVariables = {
  id: number;
};

export async function deleteExternalMailboxConfigurationFn(
  axiosInstance: Promise<AxiosInstance>,
  { id }: DeleteExternalMailboxConfigurationVariables,
) {
  const instance = await axiosInstance;

  return instance.delete(`${EXTERNAL_MAILBOX_CONFIGURATIONS_URL}/${id}`);
}

export function useDeleteExternalMailboxConfiguration() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, DeleteExternalMailboxConfigurationVariables>({
    mutationFn: variables => deleteExternalMailboxConfigurationFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: EXTERNAL_MAILBOX_CONFIGURATIONS_QUERY_KEY });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    DeleteExternalMailboxConfigurationVariables,
    'deleteExternalMailboxConfiguration'
  >('deleteExternalMailboxConfiguration', mutation);
}
